import React from "react";
import PropTypes from "prop-types";
import styles from "./style.module.scss";

export class ContextTable extends React.Component {
  render() {
    return (
      <div className={styles.contextTable}>
        <h5 className={styles.TableHeading}>{this.props.heading}</h5>
        <ul className={styles.TableUL}>
          {this.props.points.map((item, index) => (
            <li className={styles.TableLI} key={index}>
              {item}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

// Define the expected props for the component
ContextTable.propTypes = {
  heading: PropTypes.string.isRequired,
  points: PropTypes.arrayOf(PropTypes.string),
};
